var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-link-list-container",class:[
    { 'text-link-list-container--border': _vm.border },
    'text-link-list-container--' + _vm.backgroundColor
  ]},[_c('a',{staticClass:"text-link-list__link",class:{ 'text-link-list__link--thin': _vm.thin },attrs:{"href":_vm.href}},[_c('span',{staticClass:"text-link-list__text",class:{
        'text-link-list__text--bold': _vm.bold,
        'text-link-list__text--has-chevron': _vm.hasChevron
      }},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]),_vm._v(" "),(_vm.hasChevron)?_c('ChevronRight',{class:'text-link-list__chevron--right--' + _vm.chevronColor}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }